export function cleanUrlString(url: string) {
  let str = url; //this.state.blogTitle.replace(/[^0-9 a-zA-Z]+/g, '');
  return str.split(' ').join('-').toLocaleLowerCase();
}